import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/settings/')({
  beforeLoad: () => {
    // Foundations 1 / B0-T1: /sysadmin/settings/features is gone with the
    // flags; Branding is the first tab now.
    throw redirect({ to: '/sysadmin/branding' });
  },
});
